const tokens = {
  core: {
    symbol: 'CORE',
    projectLink: 'https://coredao.org/',
  },
  bow: {
    symbol: 'BOW',
    address: {
      1116: '0x1a639e150d2210a4be4a5f0857a9151b241e7ae4',
      1115: '',
    },
    decimals: 18,
    projectLink: 'https://archerswap.finance/',
  },
  xbow: {
    symbol: 'xBOW',
    address: {
      1116: '0x236994dabb4e7ffb85bf76889cec8ff9ca543ba4',
      1115: '',
    },
    decimals: 18,
    projectLink: 'https://archerswap.finance/',
  },
  wcore: {
    symbol: 'WCORE',
    address: {
      1116: '0x40375c92d9faf44d2f9db9bd9ba41a3317a2404f',
      1115: '',
    },
    decimals: 18,
    projectLink: 'https://coredao.org/',
  },
  hunt: {
    symbol: 'HUNT',
    address: {
      1116: '0x962D45C91e2e4f29DdC96C626976ECE600908Ba6',
      1115: '',
    },
    decimals: 18,
    projectLink: 'https://archerswap.finance/',
  },
  usdt: {
    symbol: 'USDT',
    address: {
      1116: '0x900101d06A7426441Ae63e9AB3B9b0F63Be145F1',
      1115: '',
    },
    decimals: 6,
    projectLink: 'https://tether.to/',
  },
  usdc: {
    symbol: 'USDC',
    address: {
      1116: '0xa4151B2B3e269645181dCcF2D426cE75fcbDeca9',
      1115: '',
    },
    decimals: 6,
    projectLink: 'https://www.centre.io/',
  },
  // dai: {
  //   symbol: 'DAI',
  //   address: {
  //     1116: '0x6De33698e9e9b787e09d3Bd7771ef63557E148bb',
  //     1115: '',
  //   },
  //   decimals: 18,
  //   projectLink: 'https://makerdao.com/',
  // },
  eth: {
    symbol: 'WETH',
    address: {
      1116: '0xeAB3aC417c4d6dF6b143346a46fEe1B847B50296',
      1115: '',
    },
    decimals: 18,
    projectLink: 'https://weth.io/',
  },
  fourToken: {
    symbol: '4TOKEN',
    address: {
      1116: '0x98564E70c7fCC6d947fFE6d9EfeD5ba68b306F2E',
      1115: '',
    },
    decimals: 18,
    projectLink: 'https://4ignorefud.com',
  },
  acore: {
    symbol: 'ACORE',
    address: {
      1116: '0x1c92E17CD1893e8535F48b03fE1207A1B12EaEAB',
      1115: '',
    },
    decimals: 18,
    projectLink: 'https://autocore.finance',
  },
  poon: {
    symbol: 'POON',
    address: {
      1116: '0x66B96135d0c639D53e1f23b7a5849F6022883b41',
      1115: '',
    },
    decimals: 18,
    projectLink: 'https://spoon.exchange',
  },
  h4token: {
    symbol: 'H4TOKEN',
    address: {
      1116: '0x719F4AA5572C3b15d0774782C770f5F6DE79410b',
      1115: '',
    },
    decimals: 18,
    projectLink: 'https://www.hignorefud.site/',
  },
  vita: {
    symbol: 'VITA',
    address: {
      1116: '0x8B35EBA17879eC1dC2786046a3D3e10E7CB44494',
      1115: '',
    },
    decimals: 18,
    projectLink: 'https://vitamincore.financial/',
  },
  btc: {
    symbol: 'BTC.b',
    address: {
      1116: '0x2297aEbD383787A160DD0d9F71508148769342E3',
      1115: '',
    },
    decimals: 8,
    projectLink: 'https://bitcoin.org/',
  },
  cdao: {
    symbol: 'cDAO',
    address: {
      1116: '0x42077e348702f13Ea80CE6a6A38b8b60fbb37B5d',
      1115: '',
    },
    decimals: 18,
    projectLink: 'https://cdao.global',
  },
  // matic: {
  //   symbol: 'MATIC',
  //   address: {
  //     1116: '0xdd90E5E87A2081Dcf0391920868eBc2FFB81a1aF',
  //     1115: '',
  //   },
  //   decimals: 18,
  //   projectLink: 'https://polygon.technology/',
  // },
  // bnb: {
  //   symbol: 'WBNB',
  //   address: {
  //     1116: '0x7f27352D5F83Db87a5A3E00f4B07Cc2138D8ee52',
  //     1115: '',
  //   },
  //   decimals: 18,
  //   projectLink: 'https://www.binance.com/',
  // },
  // busd: {
  //   symbol: 'BUSD',
  //   address: {
  //     1116: '0x4Bf769b05E832FCdc9053fFFBC78Ca889aCb5E1E',
  //     1115: '',
  //   },
  //   decimals: 18,
  //   projectLink: 'https://www.binance.com/',
  // },
}

export default tokens
